/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InfrastructureStats
 */
export interface InfrastructureStats {
    /**
     * 
     * @type {number}
     * @memberof InfrastructureStats
     */
    siteCount: number;
    /**
     * 
     * @type {number}
     * @memberof InfrastructureStats
     */
    siteWithPolygons: number;
    /**
     * 
     * @type {number}
     * @memberof InfrastructureStats
     */
    siteWithEquipment: number;
    /**
     * 
     * @type {Date}
     * @memberof InfrastructureStats
     */
    lastUpdatedAt: Date;
}

/**
 * Check if a given object implements the InfrastructureStats interface.
 */
export function instanceOfInfrastructureStats(value: object): value is InfrastructureStats {
    if ((!('siteCount' in (value as Record<string, any>)) && !('site_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['siteCount'] === undefined && (value as Record<string, any>)['site_count'] === undefined)) return false;
    if ((!('siteWithPolygons' in (value as Record<string, any>)) && !('site_with_polygons' in (value as Record<string, any>))) || ((value as Record<string, any>)['siteWithPolygons'] === undefined && (value as Record<string, any>)['site_with_polygons'] === undefined)) return false;
    if ((!('siteWithEquipment' in (value as Record<string, any>)) && !('site_with_equipment' in (value as Record<string, any>))) || ((value as Record<string, any>)['siteWithEquipment'] === undefined && (value as Record<string, any>)['site_with_equipment'] === undefined)) return false;
    if ((!('lastUpdatedAt' in (value as Record<string, any>)) && !('last_updated_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['lastUpdatedAt'] === undefined && (value as Record<string, any>)['last_updated_at'] === undefined)) return false;
    return true;
}

export function InfrastructureStatsFromJSON(json: any): InfrastructureStats {
    return InfrastructureStatsFromJSONTyped(json, false);
}

export function InfrastructureStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfrastructureStats {
    if (json == null) {
        return json;
    }
    return {
        
        'siteCount': json['site_count'],
        'siteWithPolygons': json['site_with_polygons'],
        'siteWithEquipment': json['site_with_equipment'],
        'lastUpdatedAt': (new Date(json['last_updated_at'])),
    };
}

export function InfrastructureStatsToJSON(json: any): InfrastructureStats {
    return InfrastructureStatsToJSONTyped(json, false);
}

export function InfrastructureStatsToJSONTyped(value?: InfrastructureStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'site_count': value['siteCount'],
        'site_with_polygons': value['siteWithPolygons'],
        'site_with_equipment': value['siteWithEquipment'],
        'last_updated_at': value['lastUpdatedAt'].toISOString(),
    };
}

